import { searchBox as searchBoxWidget } from 'instantsearch.js/es/widgets';

let searchDebouncingTimer;

export const searchBox = ({ container }) =>
  searchBoxWidget({
    container,
    placeholder: 'Keyword',
    showSubmit: false,
    showReset: false,
    showLoadingIndicator: false,
    cssClasses: {
      input: `block w-full px-4 py-3 border-gray-300 rounded-md focus:ring focus:ring-primary-200 focus:ring-opacity-50 focus:border-primary-300 transition`,
    },
    queryHook(query, refine) {
      clearTimeout(searchDebouncingTimer);

      searchDebouncingTimer = setTimeout(() => refine(query), 300);
    },
  });
